import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';

import { Feature } from '../models/feature.model';
import { RememberFeature } from '../states/feature-state.actions';
import { FeatureState } from '../states/feature.state';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  public features$: Observable<Feature[]>;

  constructor(private store: Store) {
    this.features$ = this.store.select(FeatureState.getFeatures);
  }

  public updateFeature(
    featureName: string,
    featureValue: any
  ): Observable<any> {
    if (!!featureName && featureName !== '') {
      return this.store.dispatch(
        new RememberFeature(new Feature(featureName, featureValue))
      );
    }

    return of({});
  }
}
